/** Store → Collections list. */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Empty, Space, Table, Tag } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from '../../../shared/i18n';
import { StatusTag, listOf, sitePath, useLoad, useSite } from './common';
import { Thumb } from './ShopCommon';

const Collections = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { api, siteId } = useSite();
    const { data, loading } = useLoad(() => api.get('/collections').catch((e) => (e.status === 404 ? [] : Promise.reject(e))), [api]);
    const rows = listOf(data);
    const create = () => navigate(sitePath(siteId, 'collections/new'));
    return (
        <Card title={t('Collections')} extra={<Button type="primary" icon={<PlusOutlined />} onClick={create}>{t('Create collection')}</Button>}>
            <Table
                rowKey="id"
                loading={loading}
                dataSource={rows}
                pagination={rows.length > 50 ? { pageSize: 50 } : false}
                scroll={{ x: 600 }}
                onRow={(c) => ({ onClick: () => navigate(sitePath(siteId, `collections/${c.id}`)), style: { cursor: 'pointer' } })}
                columns={[
                    { title: t('Title'), key: 'title', render: (_, c) => <Space><Thumb src={c.image?.src} /><a>{c.title}</a></Space> },
                    { title: t('Products', { context: 'shop' }), dataIndex: 'products_count', width: 100 },
                    { title: t('Type'), dataIndex: 'kind', width: 110, render: (v) => <StatusTag value={v} /> },
                    { title: t('Visibility'), dataIndex: 'published', width: 120, render: (v) => (v ? <Tag color="green">{t('Visible')}</Tag> : <Tag>{t('Hidden')}</Tag>) },
                ]}
                locale={{ emptyText: <Empty description={t('No collections yet')}><Button type="primary" icon={<PlusOutlined />} onClick={create}>{t('Create collection')}</Button></Empty> }}
            />
        </Card>
    );
};

export default Collections;
